(function () {
  document.querySelectorAll('[id^="ing-"]').forEach(function (section) {
    var tabBtns = section.querySelectorAll('[data-ing-tab-btn]');
    var panels = section.querySelectorAll('[data-ing-panel]');

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');

        tabBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-tab') === target);
        });
      });
    });

    section.querySelectorAll('[data-ing-plus]').forEach(function (plusBtn) {
      plusBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = plusBtn.closest('.ing-card');
        if (card) card.classList.toggle('is-open');
      });
    });
  });
})();